import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "info-icon",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.2334 5.52148L7.58984 9.1543H8.36621L8.71777 5.52148V3.8418H7.2334V5.52148Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.29199 9.62793V11H8.66406V9.62793H7.29199Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15 8C15 11.866 11.866 15 8 15C4.13401 15 1 11.866 1 8C1 4.13401 4.13401 1 8 1C11.866 1 15 4.13401 15 8ZM14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z",
  fill: "currentColor"
}, null, -1);
const _hoisted_5 = [_hoisted_2, _hoisted_3, _hoisted_4];
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5);
}